export default __webpack_public_path__ + "static/media/Poppins.8081832f.ttf";